import TieredInterventionsHeader from './component'
export default TieredInterventionsHeader
